import { getCurrentUser } from 'aws-amplify/auth';
import config from '../../../src/aws-exports';

document$.subscribe(async () => {
  Amplify.configure(config);

  /**
   * If there is no current user, redirect to the main app which
   * will show the login page.
   */
  try {
    await getCurrentUser();
  } catch (e) {
    window.location = '/';
  }
});
